// 根据用户提供的哈雷彗星预览亮度模型生成，保留非对称尾部与曝光曲线。
let cached: HTMLCanvasElement | undefined;
export const COMET_HEAD_X = 160;
export const COMET_HEAD_Y = 380;
export function createCometTexture(): HTMLCanvasElement {
  if (cached) return cached;
  function seeded(seed: number) { let v = seed >>> 0; return () => (v = (v * 1664525 + 1013904223) >>> 0) / 4294967296; }
const HX = 160, HY = 380, L = 820, SW = 1100, SH = 1000;
const sprite = document.createElement('canvas');
sprite.width = SW; sprite.height = SH;
(function buildSprite() {
  const c = sprite.getContext('2d')!;
  const img = c.createImageData(SW, SH);
  const d = img.data;
  const r = seeded(1986);
  const tone = (x: number) => 1 - Math.exp(-x * 1.25); // 软压缩，避免纯白截断出现硬边
  const smooth = (a: number, b: number, x: number) => { const t = Math.min(1, Math.max(0, (x - a) / (b - a))); return t * t * (3 - 2 * t); };
  const interp = (xs: number[], ys: number[], x: number) => {
    if (x <= xs[0]) return ys[0];
    for (let i = 1; i < xs.length; i++) {
      if (x <= xs[i]) { const f = (x - xs[i - 1]) / (xs[i] - xs[i - 1]); return ys[i - 1] + (ys[i] - ys[i - 1]) * f; }
    }
    return ys[ys.length - 1];
  };
  const P_U = [0, 60, 100, 180, 260, 340, 420, 520, 650, 820], P_V = [1, 1, 0.82, 0.51, 0.33, 0.2, 0.105, 0.05, 0.015, 0];
  const SU_U = [0, 40, 100, 180, 260, 340, 420, 820], SU_V = [14, 26, 28, 36, 40, 38, 32, 32];
  const SL_U = [0, 40, 100, 180, 260, 340, 420, 600, 820], SL_V = [14, 30, 46, 56, 62, 68, 75, 90, 100];
  const C0 = 8; // 头部中心比尾巴起点略偏上
  const colP = new Float32Array(SW), colSU = new Float32Array(SW), colSL = new Float32Array(SW), colCen = new Float32Array(SW);
  for (let x = 0; x < SW; x++) {
    const uu = Math.max(x - HX, 0);
    colP[x] = interp(P_U, P_V, uu); colSU[x] = interp(SU_U, SU_V, uu); colSL[x] = interp(SL_U, SL_V, uu);
    colCen[x] = 0.19 * (Math.sqrt(uu * uu + 14400) - 120) - C0 * Math.exp(-uu / 120); // 亮轴向下漂移
  }
  for (let y = 0; y < SH; y++) {
    for (let x = 0; x < SW; x++) {
      const u = x - HX, v = y - HY;
      const uu = Math.max(u, 0);
      const rr = Math.hypot(u, v + C0);               // 到头部中心的距离
      const sTail = v - colCen[x];
      const s = u < 0 ? (sTail >= 0 ? rr : -rr) : sTail; // 球体前方用径向距离，前缘是正圆
      const su = colSU[x], sl = colSL[x];
      const prof = s < 0 ? Math.exp(-Math.pow(-s / su, 1.6)) : Math.exp(-Math.pow(s / sl, 1.4));
      const halo = 0.10 * Math.min(1, uu / 120) * (s < 0 ? Math.exp(-Math.pow(-s / (su * 2.2), 1.2)) : Math.exp(-Math.pow(s / 150, 1.1)));
      const outer = colP[x] * (prof + halo);
      const wt = outer * outer * 1.3;                  // 越亮越偏白：白 → 青白 → 蓝
      let R = outer * 0.45 + wt, G = outer * 0.75 + wt, B = outer + wt;

      // 球形彗头：亮核 + 柔和的圆形彗发（在远处平滑归零，避免精灵边缘出现断层）
      const fade = 1 - smooth(60, 150, rr);
      const ball = 0.8 * Math.exp(-(rr / 17) * (rr / 17));
      const coma = (0.30 * Math.exp(-Math.pow(rr / 34, 1.25)) + 0.08 * Math.exp(-rr / 90)) * fade;
      const h = ball + coma;
      R += h * 0.92; G += h * 0.97; B += h;

      const Rt = tone(R), Gt = tone(G), Bt = tone(B);
      let m = Math.max(Rt, Gt, Bt);
      if (m > 0.002) {
        const n = (r() - 0.5) * 0.012; // 只做抖动，消除 8 位量化条纹
        const R2 = Rt + n, G2 = Gt + n, B2 = Bt + n;
        m = Math.max(R2, G2, B2, 0.0001);
        const i = (y * SW + x) * 4;
        d[i] = Math.min(255, Math.max(0, (R2 / m) * 255));
        d[i + 1] = Math.min(255, Math.max(0, (G2 / m) * 255));
        d[i + 2] = Math.min(255, Math.max(0, (B2 / m) * 255));
        d[i + 3] = Math.min(1, m) * 255;
      }
    }
  }
  c.putImageData(img, 0, 0);
})();

 cached = sprite; return sprite;
}
